import React from "react";
import {FaChevronRight as ArrowSymbol} from "react-icons/fa";
import {useTranslation} from "react-i18next";
import {CAView} from "./CustomerAccount";
import styles from "./CustomerAccountOverview.module.scss";
import {useCustomerContext} from "../CustomerContextProvider/CustomerContextProvider";

type CustomerAccountSection = {
  headline: string;
  links: CustomerAccountLink[];
};

type CustomerAccountLink = {
  title: string;
  url?: string;
  view?: CAView;
};

const CustomerAccountOverview: React.FC<{
  element: HTMLElement;
  openView: (evt: React.MouseEvent<HTMLAnchorElement>, view: CAView) => void;
}> = ({element, openView}) => {
  const {customer} = useCustomerContext();
  const linkCustomerOrders = element.dataset.linkcustomerorders;
  const linkCustomerBacks = element.dataset.linkcustomercreditnotes;
  const linkCustomerRatings = element.dataset.linkcustomerratings;
  const linkCustomerUserData = element.dataset.linkcustomeruserdata;
  const linkCustomerAddressData = element.dataset.linkcustomeraddressdata;
  const linkCustomerDelete = element.dataset.linkcustomerdelete;
  const linkCustomerLogOut = element.dataset.linkcustomerlogout;

  const sections: CustomerAccountSection[] = [
    {
      headline: "Ihre Bestellungen",
      links: [
        {title: "Ihre Bestellungen", url: linkCustomerOrders},
        {title: "Ihre Rücksendungen / Stornierungen", url: linkCustomerBacks},
        {title: "Ihre Artikelbewertungen", url: linkCustomerRatings},
      ],
    },
    {
      headline: "Ihre Daten & Abonnements",
      links: [
        {title: "Ihre persönlichen Daten", url: linkCustomerUserData},
        {title: "Ihre Rechnungs- und Lieferadressen", url: linkCustomerAddressData},
        {
          title: customer.newsletterFlag ? "Newsletter-Optionen" : "Zum Newsletter anmelden",
          view: CAView.Subscriptions,
        },
      ],
    },
    {
      headline: "Ihr Konto",
      links: [
        {title: "Kontolöschung beantragen", url: linkCustomerDelete},
        {title: "Ausloggen/Abmelden", url: linkCustomerLogOut},
      ],
    },
  ];

  const {t} = useTranslation("customerAccount");

  return (
    <React.Fragment>
      {sections.map((section, index) => {
        return (
          <div key={index} className={styles.accountSection}>
            <h2 className={styles.accountSectionHeader}>{t(section.headline)}</h2>
            {section.links.map((link, linkIndex) => {
              return (
                <a
                  key={`link${linkIndex}`}
                  className={styles.accountSectionLink}
                  href={link.url}
                  onClick={(e) => {
                    if (link.view) {
                      openView(e, link.view);
                    }
                  }}
                >
                  <div>{t(link.title)}</div>
                  <div className={styles.arrow}>
                    <ArrowSymbol />
                  </div>
                </a>
              );
            })}
          </div>
        );
      })}
    </React.Fragment>
  );
};

export default CustomerAccountOverview;
